import { IAction } from '../utils';

import { IBrand } from '../../interfaces/product';
import { reducerTypes } from './types';
import { IPageInfo } from '../../interfaces/common';

export interface IBrandsReducer {
  pageInfo: IPageInfo;
  brands: IBrand[];
  brandsMore: IBrand[];
  allBrands: IBrand[];
  brand?: IBrand;
  loading: boolean;
}

export const INITIAL: IBrandsReducer = {
  pageInfo: {
    pageIndex: -1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  brands: [],
  brandsMore: [],
  allBrands: [],
  loading: false,
};

export const brandsReducer = (state = INITIAL, { type, payload }: IAction) => {
  // switch (type) {
  //   case reducerTypes.GET_ALL_BRANDS:
  //     return payload;
  //   case reducerTypes.SET_PAGE:
  //     return { ...state, page: payload };
  //   default:
  //     return state;
  // }

  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_ALL_BRANDS:
      return {
        ...state,
        brands: payload,
        brandsMore: payload,
        loading: false,
      };
    case reducerTypes.GET_ALL_PUBLIC_BRANDS:
      return {
        ...state,
        allBrands: payload,
      };
    case reducerTypes.GET_MORE_BRANDS:
      return {
        ...state,
        brandsMore: [...state.brandsMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_BRAND:
      return { ...state, brand: payload };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    default:
      return state;
  }
};
